import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { updateAccidentForm } from '../../../../redux/modules/accidentClaim';
import { selectSortedCountries } from '../../../../redux/modules/countries';
import AccidentInfoStep from '../../../CompensationContainer/Steps/AccidentInfoStep';
import AccidentAddress from '../../../CompensationContainer/components/AccidentAddress';
import AccidentTime from '../../../CompensationContainer/components/AccidentTime';
import accidentInfoSchema from '../../../../validations/claimValidationSchema/accident/accidentInfoSchema';
import { ACCIDENT_INFO_FIELDS } from './options';

const AccidentStep = ({
  step,
  goNext,
  goPrevious,
  params: { setStepNavigationBox },
}) => {
  const { i18n } = useTranslation();
  const accidentClaim = useSelector((store) => store.accidentClaim, shallowEqual);
  const countries = useSelector((state) => selectSortedCountries(state, i18n.language));

  return (
    <AccidentInfoStep
      claim={accidentClaim}
      formLanguage={accidentClaim.language}
      setStepNavigationBox={setStepNavigationBox}
      step={step}
      goNext={goNext}
      goPrevious={goPrevious}
      validationSchema={accidentInfoSchema}
      requiredFields={ACCIDENT_INFO_FIELDS}
      updateForm={updateAccidentForm}
      accidentAddressComponent={<AccidentAddress />}
      accidentTimeComponent={<AccidentTime />}
      countries={countries}
    />
  );
};

AccidentStep.propTypes = {
  step: PropTypes.shape({
    claimForm: PropTypes.string.isRequired,
    n: PropTypes.number.isRequired,
  }).isRequired,
  goNext: PropTypes.func.isRequired,
  goPrevious: PropTypes.func.isRequired,
  params: PropTypes.shape({
    setStepNavigationBox: PropTypes.func.isRequired,
  }).isRequired,
};

export default AccidentStep;
